import { render } from "./SearchControlsComponent.vue?vue&type=template&id=833886de&ts=true"
import script from "./SearchControlsComponent.vue?vue&type=script&lang=ts"
export * from "./SearchControlsComponent.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./SearchControlsComponent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__